// Active listings and pre-construction units used as property references.
// Property IDs are referenced by showings and lead "interested_properties".

export const properties = [
  {
    id: 'prop-01',
    address: '9111 Collins Ave, Unit PH-4',
    neighborhood: 'Surfside',
    city: 'Miami Beach',
    state: 'FL',
    zip: '33154',
    propertyType: 'condo',
    status: 'active',
    listPrice: 14_900_000,
    beds: 5,
    baths: 6.5,
    sqft: 6_800,
    pricePerSqft: 2_191,
    yearBuilt: 2021,
    hoaMonthly: 14_500,
    waterfront: true,
    features: ['Direct ocean views', 'Private pool on terrace', '2 parking spaces', 'Wine cellar'],
    mlsId: 'A11234511',
    projectId: null,
  },
  {
    id: 'prop-02',
    address: '1000 Biscayne Blvd, Residence 5801',
    neighborhood: 'Downtown Miami',
    city: 'Miami',
    state: 'FL',
    zip: '33132',
    propertyType: 'condo',
    status: 'active',
    listPrice: 7_250_000,
    beds: 4,
    baths: 5,
    sqft: 4_200,
    pricePerSqft: 1_726,
    yearBuilt: 2022,
    hoaMonthly: 6_800,
    waterfront: true,
    features: ['Bay views', 'Private elevator entry', 'Chef kitchen', 'Staff quarters'],
    mlsId: 'A11234522',
    projectId: null,
  },
  {
    id: 'prop-03',
    address: '460 Ocean Blvd',
    neighborhood: 'Golden Beach',
    city: 'Golden Beach',
    state: 'FL',
    zip: '33160',
    propertyType: 'single_family',
    status: 'active',
    listPrice: 22_500_000,
    beds: 7,
    baths: 8.5,
    sqft: 9_400,
    pricePerSqft: 2_394,
    yearBuilt: 2023,
    hoaMonthly: 0,
    waterfront: true,
    features: ['Ocean-front lot', 'Rooftop spa', 'Guest house', 'Smart home'],
    mlsId: 'A11234533',
    projectId: null,
  },
  {
    id: 'prop-04',
    address: '6800 Fisher Island Dr, Unit 6841',
    neighborhood: 'Fisher Island',
    city: 'Miami Beach',
    state: 'FL',
    zip: '33109',
    propertyType: 'condo',
    status: 'active',
    listPrice: 11_200_000,
    beds: 4,
    baths: 5,
    sqft: 5_100,
    pricePerSqft: 2_196,
    yearBuilt: 2019,
    hoaMonthly: 9_900,
    waterfront: true,
    features: ['Fisher Island membership', 'Private marina access', 'Golf course views'],
    mlsId: 'A11234544',
    projectId: null,
  },
  {
    id: 'prop-05',
    address: '1200 Anastasia Ave',
    neighborhood: 'Coral Gables',
    city: 'Coral Gables',
    state: 'FL',
    zip: '33134',
    propertyType: 'single_family',
    status: 'active',
    listPrice: 6_450_000,
    beds: 6,
    baths: 6.5,
    sqft: 7_800,
    pricePerSqft: 827,
    yearBuilt: 2018,
    hoaMonthly: 0,
    waterfront: false,
    features: ['Gated estate', 'Home theater', 'Pool and spa', 'Wine room'],
    mlsId: 'A11234555',
    projectId: null,
  },
  {
    id: 'prop-06',
    address: '875 Harbor Dr',
    neighborhood: 'Key Biscayne',
    city: 'Key Biscayne',
    state: 'FL',
    zip: '33149',
    propertyType: 'single_family',
    status: 'active',
    listPrice: 18_950_000,
    beds: 6,
    baths: 7,
    sqft: 8_900,
    pricePerSqft: 2_129,
    yearBuilt: 2022,
    hoaMonthly: 0,
    waterfront: true,
    features: ['Deep-water dockage', 'Infinity pool', 'Guest cabana', 'Elevator'],
    mlsId: 'A11234566',
    projectId: null,
  },
  {
    id: 'prop-07',
    address: '3541 Main Hwy',
    neighborhood: 'Coconut Grove',
    city: 'Miami',
    state: 'FL',
    zip: '33133',
    propertyType: 'single_family',
    status: 'active',
    listPrice: 5_100_000,
    beds: 5,
    baths: 5.5,
    sqft: 5_600,
    pricePerSqft: 911,
    yearBuilt: 2020,
    hoaMonthly: 0,
    waterfront: false,
    features: ['Historic district', 'Walk to Grove village', 'Pool', 'Detached office'],
    mlsId: 'A11234577',
    projectId: null,
  },
  {
    id: 'prop-08',
    address: '7700 SW 126th St',
    neighborhood: 'Pinecrest',
    city: 'Pinecrest',
    state: 'FL',
    zip: '33156',
    propertyType: 'single_family',
    status: 'active',
    listPrice: 3_850_000,
    beds: 5,
    baths: 4.5,
    sqft: 5_200,
    pricePerSqft: 740,
    yearBuilt: 2017,
    hoaMonthly: 0,
    waterfront: false,
    features: ['1 acre lot', 'Tennis court', 'Pool', 'Guest suite'],
    mlsId: 'A11234588',
    projectId: null,
  },
  {
    id: 'prop-09',
    address: 'Mandarin Oriental Residences, Unit 3504',
    neighborhood: 'Brickell Key',
    city: 'Miami',
    state: 'FL',
    zip: '33131',
    propertyType: 'condo',
    status: 'preconstruction',
    listPrice: 8_900_000,
    beds: 3,
    baths: 4.5,
    sqft: 3_900,
    pricePerSqft: 2_282,
    yearBuilt: 2027,
    hoaMonthly: 7_200,
    waterfront: true,
    features: ['Bay and skyline views', 'Mandarin butler service', 'Private elevator'],
    mlsId: null,
    projectId: 'proj-mandarin-oriental',
  },
  {
    id: 'prop-10',
    address: 'St. Regis Residences, Unit 4202',
    neighborhood: 'Brickell',
    city: 'Miami',
    state: 'FL',
    zip: '33131',
    propertyType: 'condo',
    status: 'preconstruction',
    listPrice: 6_400_000,
    beds: 3,
    baths: 3.5,
    sqft: 3_200,
    pricePerSqft: 2_000,
    yearBuilt: 2028,
    hoaMonthly: 5_900,
    waterfront: true,
    features: ['Butler service', 'Bay views', 'Private office'],
    mlsId: null,
    projectId: 'proj-st-regis',
  },
  {
    id: 'prop-11',
    address: 'Cipriani Residences, Unit 2808',
    neighborhood: 'Brickell',
    city: 'Miami',
    state: 'FL',
    zip: '33131',
    propertyType: 'condo',
    status: 'preconstruction',
    listPrice: 4_600_000,
    beds: 3,
    baths: 3.5,
    sqft: 2_700,
    pricePerSqft: 1_704,
    yearBuilt: 2028,
    hoaMonthly: 4_800,
    waterfront: true,
    features: ['Cipriani members lounge', 'City views', 'Smart glass'],
    mlsId: null,
    projectId: 'proj-cipriani',
  },
  {
    id: 'prop-12',
    address: 'Casa Bella by B&B Italia, Unit 3205',
    neighborhood: 'Downtown Miami',
    city: 'Miami',
    state: 'FL',
    zip: '33132',
    propertyType: 'condo',
    status: 'preconstruction',
    listPrice: 3_250_000,
    beds: 2,
    baths: 2.5,
    sqft: 1_850,
    pricePerSqft: 1_757,
    yearBuilt: 2027,
    hoaMonthly: 3_900,
    waterfront: true,
    features: ['Lissoni furniture package', 'Bay views', 'Home automation'],
    mlsId: null,
    projectId: 'proj-casa-bella',
  },
];

export const propertyById = Object.fromEntries(properties.map((p) => [p.id, p]));
